<div class="section" id="experience">
        <div class="container cc-education">
            <div class="h4 text-center mb-4 title">Work Experience</div>
            <hr>
    <div class="colorlib-narrow-content">
       
        <div class="row">
            <div class="col-md-12">
             <div class="timeline-centered">
               <article class="timeline-entry animate-box" data-aos="fade-up" data-animate-effect="fadeInLeft">
                  <div class="timeline-entry-inner">

                     <div class="timeline-icon color-5">
                        <i class="icon-pen2"></i>
                     </div>

                     <div class="timeline-label">
                      <h4>Goodville Mutual Casualty Company , Napoleon, OH</h4>
                      <hr>
                      <h2>Software Developer II <span> May, 2020 - till present</span></h2>
                       
                       <em>
                          <li>Conferring with teams to resolve conflicts, prioritize needs, develop content criteria, or choose solutions.</li>
                          <li>Assisting with Website updates/releases.</li>
                          <li>Maintaining an understanding of the latest Web applications and programming practices through education, study, and participation in conferences, workshops, and groups.</li>
                          <li>Mainly work with repositories in BitBucket</li>
                          <li>Assist with system modernization needs</li>
                          <li>Keep documentation up on build/deploy processes for applications</li>
                          <li>Help my manager during quarterly planning</li>
                          <li>Producing clean, efficient code based on specifications</li>
                          <li>Fixing and improving existing software</li>
                          <li>Troubleshoot, debug and upgrade existing software</li>
                          <li>Recommend and execute improvements</li>
                     </em> 
                     </div>
                  </div>
               </article>
               
                 <article class="timeline-entry animate-box" data-aos="fade-up" data-animate-effect="fadeInLeft">
                    <div class="timeline-entry-inner">

                       <div class="timeline-icon color-1">
                          <i class="icon-pen2"></i>
                       </div>

                       <div class="timeline-label">
                        <h4>Connect Our Kids , REMOTE</h4>
                        <hr>
                        <h2>Software Engineer Intern<span> October 2019 - December 2019</span></h2>
                         
                         <em>
                         I worked on a team that created dashboards to help social workers, funders, and the general public understand the importance and scale of the work enabled by Connect Our Kids. 
                        This internship was provided to me by my school as part of the hands on experience portion of the curriculm.
                        </em> 
                       </div>
                    </div>
                 </article>

                 
</div>
                
                
              </div>
           </div>
       </div>
    </div>
   </div>
